import axios from "axios";
import {
  getRefreshToken,
  getTenantId,
  setLocalAccessToken,
  setLocalRefreshToken,
} from "@/lib/storeManager";

/** Check token expiration every 5 minutes dynamically. */
export const ACCESS_TOKEN_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export type TokenRefreshResponse = {
  access: string;
  refresh?: string;
};

export async function refreshAccessToken(): Promise<TokenRefreshResponse> {
  const refresh = getRefreshToken();
  if (!refresh) {
    throw new Error("Refresh token is required");
  }

  const response = await axios.post<TokenRefreshResponse>(
    `${import.meta.env.VITE_API_BASE_URL}/auth/token-refresh/`,
    new URLSearchParams({ refresh }),
    {
      headers: {
        "X-Tenant-Id": getTenantId() ?? import.meta.env.VITE_X_TENANTID,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );

  const { access, refresh: newRefresh } = response.data;
  setLocalAccessToken(access);
  if (newRefresh) {
    setLocalRefreshToken(newRefresh);
  }

  return { access, refresh: newRefresh ?? refresh };
}
